import { v5 as uuidv5 } from "uuid";

export const generateUUIDFromID = (id: string) => {
  const namespace = "your-namespace"; // Replace with your own namespace
  const fullString = `${namespace}:${id}`;
  const uuid = uuidv5(fullString, uuidv5.DNS);

  return uuid;
};
